import { GetServerSidePropsContext } from "next/types";
import { JaegerInstance, JaegerSpan, RequestWithJaeger } from "types/app";
import { ServerResponse } from "http";

export interface JaegerHelperInstance extends JaegerInstance {
  createSpan(name: string, parent?: JaegerSpan): JaegerSpan;
}

export const getJaeger = (
  req: RequestWithJaeger<GetServerSidePropsContext["req"]>
): JaegerHelperInstance => {
  const jaeger: JaegerInstance = req?.jaeger;
  if (!jaeger) {
    const proxy = new Proxy(
      {},
      {
        get: (target, key) => {
          if (
            ["createSpan", "finish", "setTag", "setTracingTag"].includes(
              key as string
            )
          ) {
            return () => proxy;
          }

          return proxy;
        },
      }
    );
    return proxy;
  }

  const create = jaeger.createSpan.bind(jaeger);

  return {
    ...jaeger,
    createSpan(
      name: string,
      parent: JaegerSpan = jaeger.currentSpan.context()
    ): JaegerSpan {
      return create(name, parent);
    },
  };
};

export const getTraceId = (
  req: GetServerSidePropsContext["req"]
): string | null => {
  return (req?.headers["uber-trace-id"] as string) || null;
};

export function setResponseTraceId(res: ServerResponse, traceId: string) {
  if (!traceId) return;
  res.setHeader("X-Trace-Id", traceId);
}
